import { TYPE_STRING } from './input-types';
import { TOTE } from '../constants';

export const id = TOTE;
export const apiKey = 'ToteName';
export const type = TYPE_STRING;

export const tote = {
  id,
  apiKey,
  type,
};
